import { createFileRoute, Link } from '@tanstack/react-router';
import { WarningCircleIcon } from '@phosphor-icons/react';
import { ProjectGeneralSettings } from '@/components/project-general-settings';
import { PageContent } from '@/components/page-content';
import { Alert } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { useProjects } from '@/hooks/use-projects';

export const Route = createFileRoute(
  '/_auth/_side-layout/project-settings/general',
)({
  component: GeneralSettings,
});

function GeneralSettings() {
  const { project } = useProjects();
  const needsDomains = !project?.domainWhitelist?.length;

  return (
    <PageContent>
      {needsDomains && (
        <Alert
          variant="default"
          icon={<WarningCircleIcon size={20} />}
          title="No tracking domains configured"
          subTitle={
            <div className="flex items-center justify-between gap-4">
              <span>
                This project accepts events from any origin. Add a domain to
                restrict tracking to your own sites.
              </span>
              <Button size="sm" variant="outline" asChild>
                <Link to="/project-settings/domains">Set up domains</Link>
              </Button>
            </div>
          }
        />
      )}
      <ProjectGeneralSettings />
    </PageContent>
  );
}
